import { jsx as m } from "react/jsx-runtime";
import { useContext as X } from "react";
import { Controller as A } from "react-hook-form";
import { useTranslation as G } from "react-i18next";
import J from "sanitize-html";
import K from "classnames";
import "../../components/Breadcrumbs/index.js";
import "../../components/Button/index.js";
import "reactjs-popup";
import { ThemeContext as O } from "../../components/ThemeContext/index.js";
import "../../modal-l0sNRNKZ.js";
import Q from "../../fields/Input/index.js";
import "../../components/Tooltip/index.js";
import "../../fields/FieldContainer/index.js";
import Y from "../../fields/Checkbox/index.js";
import "../../fields/ContentEditable/index.js";
import C from "../../fields/DateInput/index.js";
import "date-fns";
import ee from "../../fields/Select/index.js";
import "react-dropzone";
import "react-dom";
import "../../fields/InputTooltip/index.js";
import te from "../../fields/PhoneInput/index.js";
import "../../fields/SocialSelect/index.js";
import "../../fields/Switcher/index.js";
import re from "../../fields/Textarea/index.js";
import ae from "../../fields/Wysiwyg/index.js";
import ie from "../../data/phoneMasks.js";
import V, { getInputSelection as se, setInputSelection as le } from "../FillingItem/valueMutationFunctions.js";
const ne = "forma-ui__filling-input__input", ue = "forma-ui__filling-input__selectDropdown", p = {
  input: ne,
  selectDropdown: ue
}, me = {
  Rup: "А-ЯËЁ",
  Eup: "A-Z",
  R: "А-Яа-яËёЁё",
  E: "A-Za-z",
  D: "0-9",
  S: '!@№#;$:?%^&"*.,_—\\-+=()«»„“\\/ '
}, oe = (q) => q.replace(/[^0-9]/g, "").match(/(357|371|356|386|385|382|372|374)\d{8}|(77|32|36|34|31|48|40|33|46|994|995|996|353|359|420|421)[0-9]{9}|(7|0|44|1|43|30|3|358)\d{10}|(4)\d{11}/), je = ({
  data: q,
  form: l,
  search: E,
  onBlur: n,
  onChange: a,
  caseType: S,
  pattern: F,
  icon: f,
  tooltip: h,
  tooltipClass: v,
  options: R,
  ...w
}) => {
  const { t: T, i18n: N } = G(), { currencies: U, lang: j } = X(O), k = U[j], z = N.resolvedLanguage && N.resolvedLanguage !== "en" ? N.resolvedLanguage.toUpperCase() : "US", { control: _, register: x } = l, {
    type: r,
    id: t,
    inputText: y,
    errorMessage: i = T("errors.validation_required"),
    minLength: L,
    maxLength: I,
    length: u,
    mask: b,
    values: M,
    required: g = !0,
    multiple: Z,
    charset: P,
    ownVariant: B
  } = q;
  let { regexp: $ } = q;
  if ($ || (P && ($ = `^[${P.split("").map((s) => me[s]).join("")}]+$`), r === "decimal" || r === "money" ? $ = "^[0-9., ]*$" : (r === "integer" || r === "indexnumber") && ($ = "^[0-9 ]*$")), r === "email" && ($ = "^.+@.+\\..+$"), r === "date")
    return /* @__PURE__ */ m(
      A,
      {
        control: _,
        name: t,
        defaultValue: "",
        render: ({ field: { onChange: s, onBlur: o, ...c } }) => /* @__PURE__ */ m(
          C,
          {
            id: t,
            className: p.input,
            placeholder: y,
            ...w,
            ...c,
            ...x(t, {
              required: !!(g && i)
            }),
            onBlur: (e) => {
              o(), n && n(e);
            },
            onChange: (e) => {
              a && a(e), s(e);
            },
            "data-testid": `filling_item_${t}`,
            meta: {
              icon: f,
              success: l.success,
              error: l.error,
              tooltip: h,
              tooltipClass: v,
              showIconAlways: !0
            }
          }
        )
      }
    );
  if (r === "list")
    return /* @__PURE__ */ m(
      A,
      {
        control: _,
        name: t,
        defaultValue: "",
        render: ({ field: { onChange: s, onBlur: o, ...c } }) => /* @__PURE__ */ m(
          ee,
          {
            id: t,
            className: p.select,
            placeholder: y,
            ...w,
            ...c,
            ...x(t, {
              required: !!(g && i),
              pattern: { value: new RegExp($ ?? ""), message: i },
              minLength: { value: L || u, message: i },
              maxLength: { value: I || u || 250, message: i }
            }),
            onBlur: (e) => {
              o(), n && n(e);
            },
            onChange: (e, d) => {
              S === "upperFirst" && (e.target.value = V.toUpperFirst(e.target.value)), a && a(e, d), s(e);
            },
            "data-testid": `filling_item_${t}`,
            options: (M == null ? void 0 : M.map((e) => ({ label: e, value: e }))) ?? R,
            multiple: Z,
            meta: {
              icon: f,
              success: l.success,
              error: l.error,
              tooltip: h,
              tooltipClass: v,
              showIconAlways: !0,
              showArrow: !1,
              dropdownClassName: K(p.selectDropdown, `dropdown_${t}`),
              creatable: B,
              ...E
            }
          }
        )
      }
    );
  if (r === "phone")
    return /* @__PURE__ */ m(
      A,
      {
        control: _,
        name: t,
        defaultValue: "",
        render: ({ field: { onChange: s, onBlur: o, ...c } }) => /* @__PURE__ */ m(
          te,
          {
            id: t,
            className: p.input,
            placeholder: y,
            ...w,
            ...c,
            ...x(t, {
              required: !!(g && i),
              // pattern: regexp ? { value: new RegExp(regexp), message: errorMessage } : null,
              validate: (e) => g && !oe(e) ? i : !0
            }),
            onBlur: (e) => {
              o(), n && n(e);
            },
            onChange: (e) => {
              a && a(e), s(e);
            },
            defaultMaskCode: z,
            masks: ie,
            "data-testid": `filling_item_${t}`,
            icon: f,
            success: l.success,
            error: l.error,
            tooltip: h,
            tooltipClass: v,
            showIconAlways: !0
          }
        )
      }
    );
  if (r === "checkbox")
    return /* @__PURE__ */ m(
      A,
      {
        control: _,
        name: t,
        defaultValue: "",
        render: ({ field: { value: s, onChange: o, onBlur: c, ...e } }) => /* @__PURE__ */ m(
          Y,
          {
            id: t,
            className: p.ckeckbox,
            placeholder: y,
            checked: s,
            ...w,
            ...e,
            ...x(t, {
              required: !!(g && i)
            }),
            onBlur: (d) => {
              c(), n && n(d);
            },
            onChange: (d) => {
              a && a(d), o(d);
            },
            "data-testid": `filling_item_${t}`,
            icon: f,
            success: l.success,
            error: l.error,
            tooltip: h,
            tooltipClass: v,
            showIconAlways: !0
          }
        )
      }
    );
  if (r === "textarea")
    return /* @__PURE__ */ m(
      A,
      {
        control: _,
        name: t,
        defaultValue: "",
        render: ({ field: { onChange: s, onBlur: o, ...c } }) => /* @__PURE__ */ m(
          re,
          {
            id: t,
            className: p.textarea,
            placeholder: y,
            minLength: L || u,
            maxLength: I || u || 255,
            ...w,
            ...c,
            ...x(t, {
              required: !!(g && i),
              minLength: { value: L || u, message: i },
              maxLength: { value: I || u || 255, message: i }
            }),
            onBlur: (e) => {
              o(), n && n(e);
            },
            onChange: (e) => {
              a && a(e), s(e);
            },
            "data-testid": `filling_item_${t}`,
            meta: {
              icon: f,
              success: l.success,
              error: l.error,
              tooltip: h,
              tooltipClass: v,
              showIconAlways: !0
            }
          }
        )
      }
    );
  if (r === "html")
    return /* @__PURE__ */ m(
      A,
      {
        control: _,
        name: t,
        defaultValue: "",
        render: ({ field: { onChange: s, onBlur: o, ...c } }) => /* @__PURE__ */ m(
          ae,
          {
            id: t,
            className: p.wysiwyg,
            placeholder: y,
            minLength: L || u,
            maxLength: I || u || 1e3,
            ...w,
            ...c,
            ...x(t, {
              required: !!(g && i),
              minLength: { value: L || u, message: i },
              // maxLength: { value: maxLength || length || 1000, message: errorMessage },
              validate: (e) => J(e, { allowedTags: [] }).length < (I || u || 1e3) || i
            }),
            onBlur: (e) => {
              o(), n && n(e);
            },
            onChange: (e) => {
              a && a(e), s(e);
            },
            "data-testid": `filling_item_${t}`,
            icon: f,
            success: l.success,
            error: l.error,
            tooltip: h,
            tooltipClass: v,
            showIconAlways: !0
          }
        )
      }
    );
  let D;
  return ["integer", "indexnumber"].includes(r) || P === "D" ? D = "numeric" : ["decimal", "money"].includes(r) ? D = "decimal" : r === "email" && (D = "email"), /* @__PURE__ */ m(
    A,
    {
      control: _,
      name: t,
      defaultValue: "",
      render: ({ field: { onChange: s, onBlur: o, ...c } }) => /* @__PURE__ */ m(
        Q,
        {
          id: t,
          className: p.input,
          placeholder: y,
          pattern: F,
          minLength: L || u,
          maxLength: I || u || 250,
          inputMode: D,
          ...w,
          ...c,
          ...x(t, {
            required: !!(g && i),
            pattern: { value: new RegExp($ ?? ""), message: i },
            minLength: { value: L || u, message: i },
            maxLength: { value: I || u || 250, message: i }
          }),
          onBlur: (e) => {
            r === "money" ? (e.target.value = V.toPrice(e.target.value, k.code, !0), a && a(e), s(e)) : r === "decimal" && (e.target.value = V.toDecimal(e.target.value, k.code, !0), a && a(e), s(e)), o(), n && n(e);
          },
          onChange: (e) => {
            if (S === "upperFirst")
              e.target.value = V.toUpperFirst(e.target.value);
            else if (["integer", "decimal", "money"].includes(r)) {
              const d = se(e.target), H = e.target.value;
              r === "integer" ? e.target.value = V.toInt(e.target.value, k.code) : r === "decimal" ? e.target.value = V.toDecimal(e.target.value, k.code) : r === "money" && (e.target.value = V.toPrice(e.target.value, k.code));
              const W = e.target.value;
              d.end += W.length - H.length, d.start = d.end, le(e.target, d.start, d.end);
            }
            a && a(e), s(e);
          },
          "data-testid": `filling_item_${t}`,
          meta: {
            icon: f,
            success: l.success,
            error: l.error,
            tooltip: h,
            tooltipClass: v,
            mask: b == null ? void 0 : b.replaceAll("X", "*"),
            showIconAlways: !0
          }
        }
      )
    }
  );
};
export {
  je as default
};
